import { render } from "./FooterProject.vue?vue&type=template&id=1d944d0d&scoped=true"
import script from "./FooterProject.vue?vue&type=script&lang=js"
export * from "./FooterProject.vue?vue&type=script&lang=js"

import "./FooterProject.vue?vue&type=style&index=0&id=1d944d0d&lan=true&MainMampsg=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d944d0d"]])

export default __exports__